import { render } from "./Mb035.vue?vue&type=template&id=74ca8acb"
import script from "./Mb035.vue?vue&type=script&lang=js"
export * from "./Mb035.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__